import { render, staticRenderFns } from "./PaymentPage.vue?vue&type=template&id=6e3758ae&scoped=true"
import script from "./PaymentPage.vue?vue&type=script&lang=ts"
export * from "./PaymentPage.vue?vue&type=script&lang=ts"
import style0 from "./PaymentPage.vue?vue&type=style&index=0&id=6e3758ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3758ae",
  null
  
)

export default component.exports